import {
  fromJS,
  Map as ImmutableMap,
  List as ImmutableList,
} from 'immutable'
import {
  BUSINESS_CREATE_SUCCESS,
  BUSINESSES_FETCH_MANAGED_REQUEST,
  BUSINESSES_FETCH_MANAGED_SUCCESS,
  BUSINESSES_FETCH_MANAGED_FAIL,
  BUSINESSES_FETCH_PROMOTED_SUCCESS,
  BUSINESS_FRONT_PAGE_LISTINGS_EXPAND_SUCCESS,
  BUSINESS_FRONT_PAGE_LISTINGS_EXPAND_FAIL,
  BUSINESSES_FETCH_BY_SEARCH_REQUEST,
  BUSINESSES_FETCH_BY_SEARCH_SUCCESS,
  BUSINESSES_FETCH_BY_SEARCH_FAIL,
  BUSINESSES_EXPAND_BY_SEARCH_REQUEST,
  BUSINESSES_EXPAND_BY_SEARCH_SUCCESS,
  BUSINESSES_EXPAND_BY_SEARCH_FAIL,
  BUSINESS_SEARCH_QUERY_CHANGE,
  BUSINESS_SEARCH_QUERY_CLEAR,
  BUSINESS_SEARCH_ATTR_CHANGE,
  BUSINESS_SEARCH_RESET,
  BUSINESS_VIEW_CHANGE,
  BUSINESS_AVAILABLE_ATTRS_SUCCESS,
  BUSINESS_SEARCH_RESET_INNER_ATTRS,
} from '../actions/businesses'

// saved

const initialState = ImmutableMap({
  managed: ImmutableMap({
    items: ImmutableList(),
    next: null,
    isLoading: false,
    isError: false,
    isFetched: false,
  }),
  frontpage: ImmutableMap({
    items: ImmutableMap(), // recent: [id1,2,3,...], categories: {cid:[id,...],...}
    hasMore: true,
    loadedCategoryIds: ImmutableList(),
    isLoading: false,
    isError: false,
    isFetched: false,
  }),
  search: ImmutableMap({
    items: ImmutableList(),
    next: null,
    isLoading: false,
    isError: false,
    isChanged: false,
    current_items_filters: ImmutableMap(),
    filters: ImmutableMap(),
    available_attrs: null,
  }),
  promoted: ImmutableMap({}), // promotion_id_1: [id1,2,3], promotion_id_2: [id4,...],...
  promoted_category: ImmutableMap({}), // promotion_id_1 > category_id > [id1,2,3], ...
})

const setListRequested = (state, type, id) => {
  const path = id ? [type, id] : [type]
  
  // if deeply nested (i.e. with id) doesn't exist, setIn instead
  const exists = !!state.getIn(path, null)

  if (exists) {
    return state.updateIn(path, (map) => {
      return map
        .set('isLoading', true)
        .set('isFetched', false)
        .set('isError', false)
    })
  } else {
    return state.setIn(path, ImmutableMap({
      items: ImmutableList(),
      next: null,
      isLoading: true,
      isError: false,
      isFetched: false,
    }))
  }
}

const setListFailed = (state, type, id) => {
  const path = id ? [type, id] : [type]
  return state.updateIn(path, (map) => {
    return map
      .set('next', null)
      .set('items', ImmutableList())
      .set('isLoading', false)
      .set('isError', true)
      .set('isFetched', true)
  })
}

const appendToList = (state, type, id, businesses, next) => {
  const path = id ? [type, id] : [type]
  return state.updateIn(path, (map) => {
    return map
      .set('next', next)
      .set('isLoading', false)
      .set('isError', false)
      .set('isFetched', true)
      .update('items', (list) => {
        // if doesn't have any more to add, just return same
        if (!Array.isArray(businesses)) return list

        // unique
        let n = list.concat(businesses.map(item => `${item.id}`))
        n = Array.from(new Set(n))
        return fromJS(n)
      })
  })
}

export default function business_lists(state = initialState, action) {
  switch(action.type) {  
  
  case BUSINESS_FRONT_PAGE_LISTINGS_EXPAND_SUCCESS:
    try {
      const categoryIds = action.categories.map(result => result.category.id)
      const transformCategoryResults = action.categories.reduce((acc, result) => ({ ...acc, [result.category.id]: result.listings.map(listing => listing.id) }), {})

      const loadedCategoryIds = state.getIn(['frontpage', 'loadedCategoryIds'])
      let n = loadedCategoryIds.concat(categoryIds)
      n = Array.from(new Set(n))
      const dedupedLoadedCategoryIds = fromJS(n)

      if (Array.isArray(action.recent) && action.recent.length > 0) {
        state = state.setIn(['frontpage', 'items', 'recent'], action.recent.map((m) => m.id))
      }

      if (Object.keys(transformCategoryResults).length === 0) {
        state = state.setIn(['frontpage', 'hasMore'], false)
      }

      state = state.mergeIn(['frontpage', 'items', 'categories'], ImmutableMap(transformCategoryResults))
      state = state.setIn(['frontpage', 'loadedCategoryIds'], dedupedLoadedCategoryIds)
      state = state.setIn(['frontpage', 'isLoading'], false) 
    } catch (error) {
      // console.log("error:", error)
    }

    return state
  case BUSINESS_FRONT_PAGE_LISTINGS_EXPAND_FAIL:
    return setListFailed(state, 'frontpage')
  case BUSINESS_CREATE_SUCCESS:
    return appendToList(state, 'managed', null, [action.business], action.next)
  case BUSINESSES_FETCH_MANAGED_REQUEST:
    return setListRequested(state, 'managed')
  case BUSINESSES_FETCH_MANAGED_SUCCESS:
    return appendToList(state, 'managed', null, action.businesses, action.next)
  case BUSINESSES_FETCH_MANAGED_FAIL:
    return setListFailed(state, 'managed')
  case BUSINESSES_FETCH_PROMOTED_SUCCESS:
    if (!action.categoryId) {
      let newPromoted = state.get('promoted', ImmutableMap());
      let currentListings = newPromoted.get(action.promotion, ImmutableList())
      let updatedListings = currentListings.concat(action.businesses.map(item => item.id))
      newPromoted = newPromoted.set(action.promotion, updatedListings);
  
      return state.set('promoted', newPromoted)
    } else {
      let categoryState = state.getIn(['promoted_category', action.categoryId], ImmutableMap()) 
      let currentListings = categoryState.get(action.promotion, ImmutableList())
      let updatedListings = currentListings.concat(action.businesses.map(item => item.id))
      categoryState = categoryState.set(action.promotion, updatedListings)
      return state.setIn(['promoted_category', action.categoryId], categoryState)
    }
  case BUSINESSES_FETCH_BY_SEARCH_REQUEST:
    return state.withMutations((map) => {
      map.setIn(['search', 'isLoading'], true)
      map.setIn(['search', 'isError'], false)
      map.setIn(['search', 'isChanged'], false)
    })
  case BUSINESSES_FETCH_BY_SEARCH_SUCCESS:
    return state
    .setIn(['search', 'items'], ImmutableList(action.data.map(item => item.id)))
    .setIn(['search', 'next'], action.next)
    .setIn(['search', 'current_items_filters'], action.currentFilters)
    .setIn(['search', 'isLoading'], false)
    .setIn(['search', 'isError'], false)
    .setIn(['search', 'isChanged'], false)
  case BUSINESSES_EXPAND_BY_SEARCH_REQUEST:
    return state.withMutations((map) => {
      map.setIn(['search', 'isLoading'], true)
      map.setIn(['search', 'isError'], false)
      map.setIn(['search', 'isChanged'], false)
    })
  case BUSINESSES_EXPAND_BY_SEARCH_SUCCESS:
    return appendToList(state, 'search', null, action.data, action.next)
  
  case BUSINESSES_FETCH_BY_SEARCH_FAIL:
  case BUSINESSES_EXPAND_BY_SEARCH_FAIL:
    return state
    .setIn(['search', 'items'], ImmutableList())
    .setIn(['search', 'next'], null)
    .setIn(['search', 'isLoading'], false)
    .setIn(['search', 'isError'], false)
    .setIn(['search', 'isChanged'], false)

  case BUSINESS_SEARCH_QUERY_CHANGE:
    return state.withMutations((map) => {
      map.setIn(['filters', 'query'], action.value)
      map.setIn(['search', 'isChanged'], true)
    })
  case BUSINESS_SEARCH_QUERY_CLEAR:
    return state.withMutations((map) => {
      map.setIn(['search', 'filters', 'query'], '')
      map.setIn(['search', 'isChanged'], true)
    })
  case BUSINESS_SEARCH_ATTR_CHANGE:
    const setKey = Array.isArray(action.listing_key) ? ['search', 'filters', ...action.listing_key] : ['search', 'filters', action.listing_key]
    state = state.setIn(setKey, action.listing_value)
    state = state.setIn(['search', 'isChanged'], true)
    return state
  case BUSINESS_VIEW_CHANGE:
    return state.setIn(['search', 'view_tab'], action.tab)
  case BUSINESS_SEARCH_RESET:
    return state.withMutations(map => {
      map.setIn(['search', 'filters'], ImmutableMap())
      map.setIn(['search', 'isChanged'], false)
    })
  case BUSINESS_AVAILABLE_ATTRS_SUCCESS:
    return state.withMutations((map) => {
      map.setIn(['search', 'available_attrs'], fromJS(action.data))
    })
  case BUSINESS_SEARCH_RESET_INNER_ATTRS:
    return state.withMutations((map) => {
      map.setIn(['search', 'filters', 'attrs'], ImmutableMap({}))
    })
  default:
    return state
  }
}
